import { put } from 'redux-saga/effects';

import { IUserOrganization } from 'APIPackage/AuthModule/interfaces/IUserOrganization';
import { addNoticeAction } from 'CorePackage/NotificationModule/actions/NoticeActions';
import { MessageTypesEnum } from 'CorePackage/NotificationModule/enums/MessageTypesEnum';
import { NoticeTypesEnum } from 'CorePackage/NotificationModule/enums/NoticeTypesEnum';

import styles from '../components/UserLogin.module.scss';
import { regulations } from '../constants/regulations';
import { getRegulationsFile } from './getRegulationsFile';

export function* renderErrorNotices(organizations: IUserOrganization[] | undefined) {
  const renderContent = (
    <>
      Вам необходимо обратиться к администратору ЕСИА своей организации для добавления в группу доступа Регистраторы ИС
      &quot;Единый реестр проверок&quot;. Подробная инструкция по подключению:&nbsp;
      <ul className={styles.RegulationsContainer}>
        {regulations
          .filter(item => item.isReg)
          .map((item, index) => (
            <li key={index}>
              <span className={styles.RegulationsLink} onClick={getRegulationsFile(item.link, item.name)}>
                &quot;{item.name}&quot;.
              </span>
            </li>
          ))}
      </ul>
    </>
  );

  if (organizations?.length === 0) {
    yield put(
      addNoticeAction({
        renderContent,
        noticeType: NoticeTypesEnum.ERROR,
        messageType: MessageTypesEnum.ESIA_AUTHORIZATION,
      }),
    );
  } else {
    yield put(
      addNoticeAction({
        renderContent,
        noticeType: NoticeTypesEnum.ERROR,
        messageType: MessageTypesEnum.ESIA_AUTHORIZATION,
      }),
    );
    yield put(
      addNoticeAction({
        renderContent: 'Ошибка авторизации через ЕСИА',
        noticeType: NoticeTypesEnum.ERROR,
        messageType: MessageTypesEnum.ESIA_AUTHORIZATION,
      }),
    );
  }
}
